import React from 'react';
import { Button } from 'antd';
import { Hint } from '@/common/hint';

const noNativeCursorStyle = { cursor: 'default' };

const NativeDownloadButton = ({
    sourceFileName,
    hasPermission,
    onDownload,
    hasOriginalForOtherRevision = false,
    label = 'Native',
    showLabel = true,
    showIconColor = true,
    className = 'display-center',
    size,
    hintPlacement = 'bottomRight',
    hintText = 'A native exists for another revision. Please download from the document detail or toggle show all revisions',
}) => {
    const hasFile = !!sourceFileName;
    const blocked = !hasFile || !hasPermission;

    let title = 'Native';
    if (!hasPermission) title = 'No permission to access native';
    if (!hasFile) title = 'No native exists';

    let stateClass = 'common-button';
    if (!hasFile) stateClass = 'disabled-button';
    else if (!hasPermission) stateClass = 'disabled-button prohibited';

    const icon = hasFile && !hasPermission ? 'ri-prohibited-line' : 'ri-file-download-line';

    let iconStyle;
    if (showIconColor) {
        if (!hasFile) iconStyle = { color: 'var(--dms-color-text-muted)' };
        else if (!hasPermission) iconStyle = { color: 'red' };
        else iconStyle = { color: '#0860DB' };
    }

    const handleClick = (e) => {
        e.stopPropagation();
        if (blocked) return;
        onDownload?.(e);
    };

    return (
        <Button
            title={title}
            size={size}
            className={`${stateClass} original-button ${className}`}
            style={!hasFile ? noNativeCursorStyle : undefined}
            onClick={handleClick}
        >
            <i className={icon} style={iconStyle} />
            {showLabel && <span className="m-0">{label}</span>}
            {!hasFile && hasOriginalForOtherRevision && (
                <Hint
                    icon="ri-question-line"
                    popoverText={hintText}
                    placement={hintPlacement}
                />
            )}
        </Button>
    );
};

export default NativeDownloadButton;
